//FEELING MUTATIONS
export const SET_FEELING = "SET_FEELING"
export const RESET_FEELING = "RESET_FEELING"
export const RESET_USER_FEELINGS = "RESET_USER_FEELINGS"
export const PUSH_USER_FEELING = "PUSH_USER_FEELING"